import React from 'react';
import { AIChatMessage } from '@/services/api';

interface ChatToggleButtonProps {
  isOpen: boolean;
  title: string;
  messages: AIChatMessage[];
  onToggle: () => void;
}

const ChatToggleButton: React.FC<ChatToggleButtonProps> = ({ isOpen, title, messages, onToggle }) => {
  return (
    <button
      onClick={onToggle}
      className={`fixed bottom-6 right-6 z-50 flex items-center gap-2 px-4 py-3 rounded-full shadow-lg transition-all duration-200 ${
        isOpen
          ? 'bg-gray-600 hover:bg-gray-700 text-white'
          : 'bg-purple-600 hover:bg-purple-700 text-white'
      }`}
      title={isOpen ? 'Close AI Chat' : 'Open AI Chat'}
    >
      {isOpen ? (
        <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
        </svg>
      ) : (
        <>
          <svg className="h-5 w-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M9.663 17h4.673M12 3v1m6.364 1.636l-.707.707M21 12h-1M4 12H3m3.343-5.657l-.707-.707m2.828 9.9a5 5 0 117.072 0l-.548.547A3.374 3.374 0 0014 18.469V19a2 2 0 11-4 0v-.531c0-.895-.356-1.754-.988-2.386l-.548-.547z" />
          </svg>
          <span className="text-sm font-medium hidden sm:inline">{title}</span>
        </>
      )}
      {!isOpen && messages.length > 0 && (
        <span className="absolute -top-1 -right-1 h-5 w-5 bg-red-500 text-white text-xs rounded-full flex items-center justify-center">
          {messages.filter(m => m.role === 'assistant').length}
        </span>
      )}
    </button>
  );
};

export default ChatToggleButton;
